export default "__VITE_ASSET__D6bL9Rtu__"